import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { View } from './view';
import { CloneVisitor } from '@angular/compiler/src/i18n/i18n_ast';


@Injectable({
  providedIn: 'root'
})
export class FormUtil {

  constructor(public route:ActivatedRoute, public router:Router, public view:View) { 

  }


  copiarObjeto(obj){
    const clone = Object.assign({}, obj); 

    return clone;
  }
}
